import {Component, OnInit, AfterViewInit, Input} from '@angular/core';
import {trigger, style, animate, transition, query, stagger, keyframes, state, group} from '@angular/animations';
import {CommonService} from '../common.service';
import {ApiService} from '../api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AbilityConfig} from '../ability-config/ability-config';
import {PlatformLocation} from '@angular/common';
import {TokenService} from '../tokenService.service';

@Component({
  selector: 'app-case-practice-ts-report',
  animations: [
    trigger('bestPathBoxAnimation', [
      state('hideBestPathBox', style({opacity: 0, transform: 'scale(0, 0)'})),
      state('showBestPathBox', style({opacity: 1, transform: 'scale(1, 1)'})),
      transition('hideBestPathBox => showBestPathBox', animate('200ms', keyframes([
          style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
          style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
          style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
          style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
          style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
          style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
          style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
          style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
          style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
          style({transform: 'scale(1, 1)', opacity: 1})
        ]))
      ),
      transition('showBestPathBox => hideBestPathBox', animate('200ms', keyframes([
          style({opacity: 1}),
          style({opacity: 0})
        ]))
      )
    ]),
    trigger('analysisBoxAnimation', [
      state('hideAnalysisBox', style({opacity: 0, transform: 'translate(-100%)'})),
      state('showAnalysisBox', style({opacity: 1})),
      transition('hideAnalysisBox => showAnalysisBox', animate('200ms', keyframes([
          style({
            transform: 'matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '45%'
          }),
          style({
            transform: 'matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '47%'
          }),
          style({
            transform: 'matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '49%'
          }),
          style({
            transform: 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)',
            opacity: 1, left: 0, top: '50%'
          })
        ])
        )
      ),
      transition('showAnalysisBox => hideAnalysisBox', animate('500ms', keyframes([
        style({opacity: 1}),
        style({opacity: 0})
      ])))
    ]),
    trigger('starAnimation', [
      state('hideStar', style({opacity: 0})),
      state('showStar', style({opacity: 1})),
      transition('hideStar => showStar', [
        style({opacity: 1}),
        query('.starReport', style({opacity: 0})),
        query('.starReport5', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport4', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport3', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport2', animate('200ms', style({opacity: 1})), {optional: true}),
        query('.starReport1', animate('200ms', style({opacity: 1})), {optional: true})
      ])
    ])
  ],
  templateUrl: './case-practice-ts-report.component.html',
  styleUrls: ['./case-practice-ts-report.component.css',]

})
export class CasePracticeTsReportComponent implements OnInit, AfterViewInit {

  currentName: any;
  currentTotal: any;
  currentDescription: any;
  currentAnalysis: any;

  learningPathId: any;
  exerciseMetaId: any;
  practiceMetaId: any;
  userId: any;
  cardId: any;

  //报告等级KA对象：传递给等级组件
  reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean = false;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

  // chuanjie: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;
  finished: boolean;
  analysisBoxShow: boolean;
  bestPathBoxShow: boolean;
  starShow: boolean;
  reportName: string = '目标选才';

  exerciseTutor: any;
  tutor: any;
  optimum: any;

  mode: number;
  lvCls: string;

  // 皮肤样式
  skinColor: string = 'Purple';


  starPicUrl: string;

  pathClickable: boolean;
  goToListClickedStatus: boolean;
  redoClickedStatus: boolean;
  assetsRoute: string = '../../assets';

  itemClickEnable: boolean = false;
  //配置信息
  abilityConfig: AbilityConfig;

  //当前用户获得的KA
  userKA: any;

  //KaAnalysis
  KaAnalysis: any;
  practiceList: any;
  //报告
  report: any;
  isOpenClass: number = 0;
  type : string //是否为pc横版
  constructor(private commonService: CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private platformLocation: PlatformLocation,
              private tokenService: TokenService,
              private router: Router) {
  }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    this.bestPathBoxShow = false;
    this.analysisBoxShow = false;
    this.starShow = false;
    this.pathClickable = true;
    this.goToListClickedStatus = false;
    this.redoClickedStatus = false;
    this.route.queryParams.subscribe(queryParams=>{
      this.type=queryParams['type']
    })

    this.route.params.subscribe(params => {
      this.cardId = params['cardId'];
      this.exerciseMetaId = params['exerciseMetaId'];
      let isOutLink = Number(params['isOutLink']);

      if(this.platformLocation['location']['href'].indexOf('isShowBack') !== -1 || isOutLink === 1){
        localStorage.setItem('openClass','1');
      }else{
        localStorage.removeItem('openClass');
      }
      this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
      this.getLearningTour().then(result=>{
        this.userId = result.user_id;
      }).then(()=>{
        return this.createAndGetPracticeList(this.exerciseMetaId, this.userId).then(result=>{
          return this.practiceList = result;
        })
      }).then(()=>{
        return this.getLearningPathMetaId(this.practiceList.learningPathId).then(result => {
          return this.learningPathMetaId = result.data;
        })
      }).then(() => {
        return this.getExerciseTutor(this.exerciseMetaId).then(result => {
          return this.exerciseTutor = result;
        });
      }).then(() => {
        return this.getKAStar(this.cardId).then(result => {
          return this.userKA = result;
        });
      }).then(() => {
        return this.getKAAnalysis(this.exerciseMetaId).then(result => {
          return this.KaAnalysis = result;
        });
      }).then(() => {
        this.report = this.handleKaReport(this.userKA, this.KaAnalysis);
        this.mode = 4;
        this.starPicUrl = '/casepracticets/star_purple.png';
        this.tutor = this.exerciseTutor.tutor;
        this.optimum = this.exerciseTutor.optimum;
        this.reportKAData = this.setPracticeLevelDictionary(this.userKA);
        // this.optimum = '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p><p class="tsTitle fontBlod">面试前</p><p class="fontBlod">明确岗位人才画像:</p><p>对团队管理者而言，在面试前提供正确的信息，帮助招聘部门的同事制定出岗位的“人才画像”，是迈向成功招聘的第一步。</p><br/><p class="fontBlod">在这里，你需要完成两步：</p><p>第一步，通过对【关键任务】的选择，确定人才画像中的“能力”版块。基于面试前的“我”与HR的对话，【关键任务】的最佳选择是：</p><img class="tsImage" src="../../assets/picture/casepracticets/bestPath-1.png" /><br/><br/><p>第二步，确定人才画像中“动力适配性”。基于面试前的“我”与HR的对话，最佳选择是：</p><img class="tsImage" src="../../assets/picture/casepracticets/bestPath-2.png" /><br/><br/><p class="tsTitle fontBlod">面试中</p><p class="fontBlod">面试对话:</p><p><span class="fontME">我</span><span>你能跟我说一说，在开发新客户的时候，你是如何了解新客户需求的？</span></p><p><span class="fontXL">应聘者</span><span>额，看资料吧。公司通常会有关于新客户的行业背景啊、业务痛点啊之类的分析材料，我就拿着这些去开发新客户就行。</span></p><p><span class="fontME">我</span><span>能给我说说，具体是怎么开发呢？</span></p><p><span class="fontXL">应聘者</span><span>我通常会根据背景资料上给的信息，先跟客户聊聊他们现在的状况，这样让他们觉得我了解他们的行业和业务。这样一聊，通常能发现困扰客户的点在哪里，然后我一般会结合行业的趋势和他们公司的战略重点来引导他们……【应聘者开始侃侃而谈销售策略。】</span></p><p><span class="fontME">我</span><span>听上去你有很多类似的经验，能举个实际例子吗？</span></p><p><span class="fontXL">应聘者</span><span>哦，当然当然。那……我、我举一个前年我们部门开拓XX行业的成功案例吧。你可以看这个PPT，这是一个很特殊的行业：准入门槛高、客户培养周期长。我们前期对这个行业做了调研、数据、行业资深人士做了深度访谈……，然后我们找到了这么几个突破点。您看这里……，最后我们在当年就取得了开门红，超额完成了定下的指标。</span></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>当应聘者使用“通常”、“一般”等过于宽泛的情景来回答面试问题时，面试官需要通过“具体是怎么做的”、“能举个例子吗”等方式跟进发问，让应聘者的回应更聚焦。</p></div><p><span class="fontME">我</span><span>能说说你在其中具体做了些什么吗？</span></p><p><span class="fontXL">应聘者</span><span>我全程跟进了这个项目，调研分析、小组访谈，都是我做的。</span></p><p><span class="fontME">我</span><span>唔，那咱们就拿小组访谈来讲好了。【指着某一页】你们在做这家公司的时候，具体流程是怎么样的？参与者有哪些？你们设计问题的思路是什么样的？</span></p><p><span class="fontXL">应聘者</span><span>唔，让我想一想：其实……一般而言……从理论上讲，我们会这么做……</span></p><p><span class="fontME">我</span><span>【及时打断】好的，谢谢你的分享，这点上我清楚了。接下来，我想了解另一个点。</span></p><p><span class="fontXL">应聘者</span><span>好的，您说。</span></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>当应聘者使用“我们如何如何”的时候，面试官需要通过跟进提问，明确哪些才是应聘者真正的个人贡献。</p></div><p><span class="fontME">我</span><span>【看简历】我看你带了4年团队了，作为团队领导，你需要让团队有客户意识。你是怎么做的呢？</span></p><p><span class="fontXL">应聘者</span><span>我可以举个客情处理的例子。我会要求我的团队成员在系统中对客户的问题进行记录。我会每周把记录进行分类和重要性排序，并在周例会上提出并一起讨论解决方案，讨论如何更好地作出回应，并且总结经验，避免多次出现同类问题。这个措施实施了半年后，客户满意度上升到4.3（满分5分），我们公司的平均满意度为3.8分。之后的三年内我们团队的满意度一直维持到4.3-4.6之间。</span></p><p><span class="fontME">我</span><span>这个例子很完整，也很有代表性，能体现你在团队的客户意识的提升上做了什么。希望在之后的谈话中，我们也能用这样的例子交流。你觉得可以吗？</span></p><p><span class="fontXL">应聘者</span><span>可以的，没问题。</span></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>当应聘者举了一个完整的行为事例时，面试官可以给到一些肯定。</p></div><p><span class="fontME">我</span><span>刚才我们聊的是带团队。现在谈谈你自己吧，你在工作中是怎么确保客户满意的？</span></p><p><span class="fontXL">应聘者</span><span>我觉得作为销售，“以客户为中心”是最核心的职业素养，我平时都是尽己所能，做到让客户满意的。</span></p><p><span class="fontME">我</span><span>能举个例子吗？</span></p><p><span class="fontXL">应聘者</span><span>有一次，我的一个老客户想要合同范围之外，再附加一个质量管理的小需求。当时负责项目的顾问不愿意做。为了能满足客户的需求，也避免公司的品牌形象受损，我多次与资源部门协调，坚持不懈地找愿意接项目的顾问，最终把客户需要的小项目做成了。</span></p><p><span class="fontME">我</span><span>不过我有个疑问，为什么原来合作的顾问不愿意接这个“小需求”？</span></p><p><span class="fontXL">应聘者</span><span>我觉得他们是嫌工作繁琐、利润又少，体现不出他们的价值吧。</span></p><p><span class="fontME">我</span><span>好。明白。那最后的结果怎么样？</span></p><p><span class="fontXL">应聘者</span><span>应该……还行吧，项目顺利地完成了。</span></p><p><span class="fontME">我</span><span>客户满意吗？</span></p><p><span class="fontXL">应聘者</span><span>……我没有特意去问，但不至于不满意，否则一定会反馈到我这儿。</span></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>这是一个完整的行为事例，乍一看，似乎特别能展现出应聘者的“客户至上”。但是一旦详加追问，就不难发现，真实状况恰恰相反：应聘者在没有不考虑投入产出比的情况下盲目追加资源到一个价值较小的项目，最终也没有去了解效果的好坏。所以，当应聘者说出一个看似有说服力的事例时，要通过追问来窥得真相。</p></div><p><span class="fontME">我</span><span>你碰到过的最难处理、最有挑战的状况是什么?</span></p><p><span class="fontXL">应聘者</span><span>前两年我们行业出了个负面新闻，也许您听说过。对，就是“XX造假事件”，闹得很大，牵连了一大波同行。我们也不能幸免。好多客户都觉得我们这行不靠谱，想要取消合作。</span></p><p><span class="fontME">我</span><span>你是怎么应对的？</span></p><p><span class="fontXL">应聘者</span><span>我当时是一个一个电话去跟客户解释，而且即使一次两次被拒，也坚持继续与客户一遍遍沟通，直到说服客户为止。</span></p><p><span class="fontME">我</span><span>你当时的感受怎么样？</span></p><p><span class="fontXL">应聘者</span><span>刚开始有点糟心，天天接到退单的电话。但是后面一个个地把丢了的单子谈回来，这种感觉……还挺让人激动的，因为这么难都能搞定，自己很有成就感。</span></p><p><span class="fontME">我</span><span>确实是很出色的结果，真为你高兴。</span></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>在动力适配性的提问中，除了要问应聘者是怎么应对的，也要通过“你当时感受怎么样”，“你喜欢/不喜欢”等，来进行判断。</p></div><p class="tsTitle fontBlod">面试后</p><p class="fontBlod">先根据面试进行打分：</p><p>1. 我通常会根据背景资料上给的信息，先跟客户聊聊他们现在的状况，这样让他们觉得我了解他们的行业和业务。这样一聊，通常能发现困扰客户的点在哪里，然后我一般会结合行业的趋势和他们公司的战略重点来引导他们……</p><p>答案:&nbsp;&nbsp;<font color="red">无效</font></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>不是行为事例，无法从上述描述中看出应聘者在“客户至上”的具体行为。</p></div><p>2. 我也特别认同要“以客户为中心”，我平时都是尽己所能，让客户满意。最有代表性的例子是我上半年的一个客户。当时一个老客户想要合同范围之外，再附加一个质量管理的小需求。当时负责项目的顾问不愿意做。为了能满足客户的需求，也避免公司的品牌形象受损，我多次与资源部门协调，坚持不懈地找愿意接项目的顾问，最终把客户需要的小项目做成了。</p><p>答案:&nbsp;&nbsp;<font color="red">无效</font></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>这是一个负面的行为事例，应聘者在没有不考虑投入产出比的情况下盲目追加资源到一个价值较小的项目，最终也没有去了解效果的好坏，恰恰暴露了他在能力上的不足，因此也是无效的。</p></div><p>我可以举个客情处理的例子。我会要求我的团队成员在系统中对客户的问题进行记录。我会每周把记录进行分类和重要性排序，并在周例会上提出并一起讨论解决方案，讨论如何更好地作出回应，并且总结经验，避免多次出现同类问题。</p><p>答案:&nbsp;&nbsp;<font color="green">有效</font></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>完整的行为事例，而且能证明他在“客户至上”能力的表现，所以是有效的。</p></div><p>4. 刚入行时，我曾经碰到一个挺难搞定的项目。为了让客户的决策人拍板，我花了功夫去打听决策人的情况，发现他偏头痛一直看不好，我特意帮他牵线搭桥，介绍了个挺难约的医生。最终帮客户解决了烦恼，我的单子也谈下来了。</p><p>答案:&nbsp;&nbsp;<font color="red">无效</font></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>完整的行为事例，但是与客户打“人际感情牌”，并不能证明他在“客户至上”能力的表现，因此也是无效的。</p></div><p class="fontBlod">关于“动力适配性：职业挑战”的行为事例：</p><p>1. 前两年我们行业出了个负面新闻，我的客户也因此产生了不信任，想要退单。我短时间内坚持不懈地与客户一遍遍沟通，直到说服客户为止。虽然很难，但是一个个地把丢了的单子谈回来，这种难关的攻克太有成就感了。</p><p>答案:&nbsp;&nbsp;<font color="green">有效</font></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>完整的行为事例，而且体现了“职业挑战”能够激励他，所以是有效的。</p></div><p class="fontBlod">所以，应聘者的得分情况：</p><div class="bg-lightPurple"><p class="smLineHeight">能力：客户至上</p><p class="smLineHeight">正确答案：2分</p><p class="smLineHeight">动力适配性：职业挑战</p><p class="smLineHeight">正确答案：3分</p><p class="excellentDemonstrationTitle"> 点 评</p><p>从上述的行为事例来看，能够展现“客户至上”正面行为只有一个“客情处理”的事例，而其他的事例要么是无效的，要么是负面的，因此在你的面试中，应聘者的能力尚未达到预期标准，也就是2分。而在动力适配性上，他展现的行为事例是有效的，而且确实一个挺有挑战的场景，因此根据你的面试，可以给到3分。</p></div><p class="tsTitle fontBlod">最终的选择:</p><p><span class="fontWY">老板</span><span>许利是不是适合的人选？</span></p><p><span class="fontME">我</span><span>不选。</span></p><p><span class="fontWY">老板</span><span>我看这个人学历、背景都挺好，为什么不要？</span></p><p><span class="fontME">我</span><span>现阶段有些挺重要的能力，他的表现不突出。</span></p><p><span class="fontWY">老板</span><span>哪些能力？</span></p><p><span class="fontME">我</span><span>客户至上、业务敏锐度。</span></p><div class="bg-lightPurple"><p class="excellentDemonstrationTitle"> 点 评</p><p>综合你和其他面试官的打分与评价，许利在客户至上和业务敏锐度能力还有欠缺，确实并非理想人选。</p></div>';
        this.lvCls = this.reportKAData ? this.lvCls = this.mode + ' bgBlur' : this.lvCls = this.mode + '';
        this.isShowReportLv = this.lvCls.indexOf('bgBlur') === -1 ? false : true;
        setTimeout(() => {
          this.itemClickEnable = true;
        }, 500);
      });
    });
  }

  ngAfterViewInit() {
    let that = this;
    this.commonService.initPage({
      'backgroundColor': 'white'
    });
    $(document).ready(function () {
      var listenerTimeout = setInterval(function () {
        var bestPathEle = document.getElementById('bestPathBox'),
          analysisEle = document.getElementById('analysisContent'),
          tutorEle = document.getElementById('tourReviewBox');
        if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
          bestPathEle.addEventListener('scroll', that.onBestPathScroll);
          analysisEle.addEventListener('scroll', that.onAnalysisScroll);
          tutorEle.addEventListener('scroll', that.onTutorScroll);
          clearInterval(listenerTimeout);
        }
      }, 500);
    });
  }

  //关闭
  close() {
    this.apiService.getOrCreateLearningPath(String(this.learningPathMetaId)).subscribe(result=>{
      //转向情景列表
      let link = this.abilityConfig.getPracticeLinkList(result.name, this.learningPathId, this.practiceMetaId);
      if (link.length > 0 && this.isOpenClass === 0 ) {
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate(link);
        }
      }else{
        if(this.type){
          if(this.learningPathMetaId == 201){
            this.router.navigate(['egret-practice-ts','20101'],{queryParams:{type:'huatek'}});
          }else if(this.learningPathMetaId == 301){
            this.router.navigate(['egret-practice-ts','30101'],{queryParams:{type:'huatek'}});
          }
        }else{
          if(this.learningPathMetaId == 201){
            this.router.navigate(['egret-practice-ts','20101']);
          }else if(this.learningPathMetaId == 301){
            this.router.navigate(['egret-practice-ts','30101']);
          }

        }
      }
    });
  }

  createAndGetPracticeList(exerciseMetaId, userId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sim/v1/simulation/' + exerciseMetaId +'/createAndGet'
      // 'url': this.commonService.getOrigin()+'/sim/v1/simulation/' + exerciseMetaId +'/createAndGet?userId='+userId
    }).toPromise();
  }


  onBestPathScroll() {
    var overlay = document.getElementById('bestPathBox');
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onAnalysisScroll() {
    var overlay = document.getElementById('analysisContent');
    console.log('scroll1');
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onTutorScroll() {
    var overlay = document.getElementById('tourReviewBox');
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight < 1) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  subWrapOneOut() {
    $('#subWrapOne').fadeOut(function () {
      $('#subWrapTwo').fadeIn();
      $('#btnWrap').fadeIn();
    });
  }

  tourReviewBoxIn() {
    $('#tourReviewShade').fadeIn();
    $('#tourReviewBox').fadeIn();
    $('.closeBtn' + this.skinColor).fadeIn();
    this.pathClickable = false;
  }

  tourReviewBoxOut() {
    $('#tourReviewShade').fadeOut();
    $('#tourReviewBox').fadeOut();
    $('.closeBtn' + this.skinColor).fadeOut();
    this.pathClickable = true;
  }

  bestPathIn() {
    if (!this.pathClickable) {
      return;
    }
    $('.closeBtn' + this.skinColor).fadeIn();
    this.bestPathBoxShow = true;
    $('#shade').fadeIn();
  }

  bestPathOut() {
    $('.closeBtn' + this.skinColor).fadeOut();
    this.bestPathBoxShow = false;
    $('#shade').fadeOut();
  }


  //操作拼接报告
  handleKaReport(userKA, KaAnalysis) {
    let report = [];
    for (let i = 0, len = userKA.length; i < len; i += 1) {
      report[i] = {};
      report[i]['id'] = KaAnalysis[i]['id'];
      report[i]['name'] = KaAnalysis[i]['name'];
      report[i]['value'] = userKA[i]['star'];
      report[i]['description'] = KaAnalysis[i]['description'];
      report[i]['analysis'] = KaAnalysis[i]['analysis' + report[i]['value']];
    }
    return report;
  }

  //获取learningTour
  getLearningTour() {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/learningtournew'
    }).toPromise();
  }

  //获取优秀示范
  getExerciseTutor(exerciseMetaId) {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/exerciseTutor/' + this.exerciseMetaId
    }).toPromise();
  }

  //获取KAAnalysis
  getKAAnalysis(exerciseMetaId) {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sim/v1/simulation/multiExerciseMetas/' + exerciseMetaId + '/getKaAnalysis'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/multiExerciseMetas/' + exerciseMetaId + '/getKaAnalysis'
    }).toPromise();
  }

  //获取learningPathMetaId
  getLearningPathMetaId(learningPathId) {
    return this.apiService.ajax({
      'type': 'get',
      'url': '/ddilearner/v1/getLearningPathMetaId/' + learningPathId
    }).toPromise();
  }


  //重做
  redo() {
    if (!this.pathClickable || this.redoClickedStatus) {
      return;
    } else {
      this.redoClickedStatus = true;
    }

    let channel = document.getElementById('resource_route');
    let origin = channel.dataset.src === ''? this.commonService.getOrigin() : 'https://m.transtalent.cn';
    let params = channel.dataset.src === ''? '' : '&channelHost='+this.commonService.getOrigin()+'/yyddi/';
    this.createNewCard(this.exerciseMetaId, this.userId).then(() => {
      let originUrl = origin + '/simulation/' + this.exerciseMetaId + '/index.html?userId=' + this.userId + '&learningPathMetaId=' + this.learningPathMetaId + '&simulationId=' + this.exerciseMetaId + '&token=' + this.tokenService.findToken() + '&userIdEncoder=' + this.tokenService.findUserIdEncoder();
      this.platformLocation['location']['href'] = this.isOpenClass === 1 ? originUrl + '&isShowBack=0': this.type === 'huatek'?  originUrl+'&type=huatek' : originUrl+params;
    });


  }

  //获取KA Star
  getKAStar(cardId) {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sim/v1/simulation/card/' + cardId + '/getKaStar'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/card/' + cardId + '/getKaStar'
    }).toPromise();
  }

  //创建新的流水卡
  createNewCard(exerciseMetaId, userId) {
    return this.apiService.ajax({
      'type': 'POST',
      'url': '/sim/v1/simulation/' + exerciseMetaId + '/card'
      // 'url': this.commonService.getOrigin() + '/sim/v1/simulation/' + exerciseMetaId + '/card?userId=' + userId
    }).toPromise();
  }

  analysisBoxIn(i) {
    if (!this.itemClickEnable) {
      return false;
    }
    let _this = this;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].value;
    this.currentAnalysis = this.report[i].analysis;
    $('#analysisShade').fadeIn();
    // 滚动到订端
    $('#analysisContent').scrollTop(0);
    // $('#analysisBox').fadeIn();
    this.analysisBoxShow = true;
    $('body').css('overflow-y', 'hidden');
    setTimeout(function () {

      _this.starShow = true;

    }, 300);

    this.pathClickable = false;

    document.getElementById('analysisShade').ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById('analysisHead').ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById('closeBtn3').ontouchmove = function (e) {
      e.preventDefault();
    };

  }

  analysisBoxOut() {

    $('#analysisShade').fadeOut();
    this.analysisBoxShow = false;
    $('body').css('overflow-y', 'scroll');
    this.starShow = false;
    this.pathClickable = true;

  }

  // 返回列表
  goToList() {
    if (this.goToListClickedStatus) {
      return;
    } else {
      this.goToListClickedStatus = true;
    }

    this.close();

  }

  //设置等级参数
  setPracticeLevelDictionary(userKA) {
    let finalScore = 0;
    userKA.forEach((v) => {
      finalScore += v['star'];
    }, 0);

    //计算等级
    let level = (finalScore < 7 && 1) || (finalScore < 12 && finalScore >= 7 && 2) || (finalScore < 20 && finalScore >= 12 && 3) || (finalScore >= 20 && 4) || 0;
    //计算description
    let description = {
      1: '偶有马失前蹄，怎么办？当然是继续努力啦~',
      2: '让自己变强的方法，就是练习、练习、再练习。',
      3: '离满分仅一步之遥，要不要再试一次？',
      4: '恭喜优秀的面试官，完美通关！'
    }[level] || '错误的等级，无法获取相应的description';

    return {
      'level': level,
      'description': description
    };
  }

  //进入后测
  linkToPostSurvey() {
    this.apiService.getOrCreateLearningPath(this.learningPathMetaId).subscribe(result => {
      this.learningPath = result;
      if (this.learningPath.subItems.length == 3) {

        this.getLearningTour().then(result => {
          this.learningTour = result;
          let link = ['survey', this.learningTour.tour_id, 3, 2];
          this.router.navigate(link);
        });
      } else {
        let link = ['survey', this.learningPath.id, this.learningPath.subItems[4].surveyMetaId, 1];
        this.router.navigate(link);
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/case-practice-ts-report/case-practice-ts-report.component.ts